module.exports = __webpack_public_path__ + "media/images/ic-arrow-down-branca-33fac642f5bb44343e18ec9e79ad7e9f.svg";